/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPermissionsBrandAndMarketFilter
 */
export interface UserPermissionsBrandAndMarketFilter {
    /**
     * 
     * @type {number}
     * @memberof UserPermissionsBrandAndMarketFilter
     */
    limit?: number;
    /**
     * 
     * @type {string}
     * @memberof UserPermissionsBrandAndMarketFilter
     */
    term?: string | null;
}

export function UserPermissionsBrandAndMarketFilterFromJSON(json: any): UserPermissionsBrandAndMarketFilter {
    return UserPermissionsBrandAndMarketFilterFromJSONTyped(json, false);
}

export function UserPermissionsBrandAndMarketFilterFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPermissionsBrandAndMarketFilter {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'term': !exists(json, 'term') ? undefined : json['term'],
    };
}

export function UserPermissionsBrandAndMarketFilterToJSON(value?: UserPermissionsBrandAndMarketFilter | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'limit': value.limit,
        'term': value.term,
    };
}


